//정기식 운영 지점 목록은 하드코딩하지 않음 - 서버 /dashboard/restaurant/regularmeal/mysetting 에서 지점별 설정을 받아옴
export const dontNeedSunbaePayAcademies = () => {

    return ["alltarget"];

}

export const oneMealTicketPrice = 8000;